// assets/cintillo-diario.js
(function () {
  var BODY_PADDING_PX = 64;

  // Cuando mode=hide y llega con UTM, marcamos la sesión para ocultar en navegación interna
  var SESSION_KEY = "cintillo_hide_for_utm_session";

  function pad2(n) {
    return (n < 10 ? "0" : "") + n;
  }

  function setBodyOffset(enabled) {
    try {
      document.body.style.paddingTop = enabled ? BODY_PADDING_PX + "px" : "";
    } catch (e) {}
  }

  // Detecta si en la URL actual existe CUALQUIER query param que empiece con utm_
  function hasAnyUtmInUrl() {
    try {
      var params = new URLSearchParams(window.location.search);
      var it = params.keys();
      var k = it.next();
      while (!k.done) {
        var key = (k.value || "").toLowerCase();
        if (key && key.indexOf("utm_") === 0) return true;
        k = it.next();
      }
    } catch (e) {}
    return false;
  }

  // Activa variante UTM o normal para:
  // - link (href)   -> data-href / data-href-utm
  // - texto desktop -> data-text2 / data-text2-utm (opcional)
  // Además, si aún tienes ambos nodos en el DOM (normal vs utm), también los soporta.
  function applyUtmVariant(el, hasUtm) {
    // ===== Link =====
    // Recomendado: un solo <a> con data-href y data-href-utm en el section.
    var linkEl =
      el.querySelector("[data-cintillo-link]") ||
      el.querySelector("a.link-block-45") ||
      el.querySelector("a");

    if (linkEl) {
      var hrefNormal = (linkEl.getAttribute("data-href") || "").trim();
      var hrefUtm = (linkEl.getAttribute("data-href-utm") || "").trim();

      // fallback: si el section aún no tiene data-href*, no tocamos href
      if (hrefNormal || hrefUtm) {
        var finalHref = hasUtm ? (hrefUtm || hrefNormal) : (hrefNormal || hrefUtm);
        if (finalHref) linkEl.setAttribute("href", finalHref);
      }
    }

    // ===== Texto desktop (text_cint2 vs text_cint2_utm) =====
    // Opción A (recomendada): un solo nodo con data-text2/data-text2-utm
    var text2El = el.querySelector("[data-cintillo-text2]");

    if (text2El) {
      var tNormal = text2El.getAttribute("data-text2") || "";
      var tUtm = text2El.getAttribute("data-text2-utm") || "";
      text2El.textContent = hasUtm ? (tUtm || tNormal) : (tNormal || tUtm);
      return;
    }

    // Opción B (legacy): dos nodos duplicados en el DOM.
    // Para soportarlo sin romper, intentamos detectar los dos y ocultar/mostrar.
    // Importante: esto asume que en el section les pondrás data-variant="default|utm"
    // o clases distintas; si no existen, no hacemos nada.
    var defaultTextNode = el.querySelector('[data-variant="default"][data-role="text2"]');
    var utmTextNode = el.querySelector('[data-variant="utm"][data-role="text2"]');

    if (defaultTextNode || utmTextNode) {
      if (defaultTextNode) defaultTextNode.style.display = hasUtm ? "none" : "";
      if (utmTextNode) utmTextNode.style.display = hasUtm ? "" : "none";
    }
  }

  function initCintillo(el) {

  setTimeout(function () {

    var bandera = document.getElementById("bandera_cintillo");

    if (!bandera) {
      console.log("NO HAY BANDERA");
      el.style.display = "none";
      setBodyOffset(false);
      return;
    }

    console.log("SI HAY BANDERA");

    var mode = (el.getAttribute("data-utm-visibility-mode") || "default")
      .toLowerCase()
      .trim();

    var hasUtm = hasAnyUtmInUrl();

    // Si mode=hide y llega con UTM en ESTA URL -> marca sesión
    if (mode === "hide" && hasUtm) {
      try {
        sessionStorage.setItem(SESSION_KEY, "1");
      } catch (e) {}
    }

    // Si mode=hide y la sesión está marcada -> ocultar el cintillo + quitar padding
    if (mode === "hide") {
      var flagged = false;
      try {
        flagged = sessionStorage.getItem(SESSION_KEY) === "1";
      } catch (e) {}

      if (flagged) {
        el.style.display = "none";
        setBodyOffset(false);
        return;
      }
    }

    // Si mode=show, lo tratamos como "siempre mostrar"
    if (mode === "show") {
      try {
        sessionStorage.removeItem(SESSION_KEY);
      } catch (e) {}
    }

    // Si llegamos acá, el cintillo se muestra
    el.style.display = "";
    setBodyOffset(true);

    // Aplica variante UTM (link + texto) solo si se va a ver
    applyUtmVariant(el, hasUtm);

    // ====== Cuenta regresiva ======
    var fechaStr = el.getAttribute("data-fecha-objetivo") || "";
    var fechaObjetivoMs = new Date(fechaStr).getTime();

    var counter = el.querySelector("#counter_cintillo");
    var horasEl = el.querySelector("#horas");
    var minsEl = el.querySelector("#minutos");
    var segsEl = el.querySelector("#segundos");
    var lHoras = el.querySelector("#l_horas");
    var lMins = el.querySelector("#l_minutos");
    var lSegs = el.querySelector("#l_segundos");

    // Si falta DOM del contador, igual mantenemos el padding (cintillo visible),
    // pero evitamos errores.
    if (!counter || !horasEl || !minsEl || !segsEl) return;

    // Fecha inválida -> ocultamos TODO el cintillo y quitamos padding
    if (!isFinite(fechaObjetivoMs)) {
      el.style.display = "none";
      setBodyOffset(false);
      return;
    }

    var timerId = setInterval(function () {
      var ahoraMs = Date.now();
      var distanciaPromo = fechaObjetivoMs - ahoraMs;

      // Promo terminó -> ocultar TODO el cintillo + quitar padding
      if (distanciaPromo < 0) {
        clearInterval(timerId);
        el.style.display = "none";
        setBodyOffset(false);
        return;
      }

      // Promo vigente -> mostrar contador
      counter.style.display = "flex";

      // Cuenta regresiva hacia medianoche del día actual
      var ahora = new Date();
      var finDeHoy = new Date(
        ahora.getFullYear(),
        ahora.getMonth(),
        ahora.getDate() + 1,
        0, 0, 0, 0
      );

      var distancia = finDeHoy.getTime() - ahora.getTime();

      var horas = Math.floor(
        (distancia % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );

      var minutos = Math.floor(
        (distancia % (1000 * 60 * 60)) / (1000 * 60)
      );

      var segundos = Math.floor(
        (distancia % (1000 * 60)) / 1000
      );

      if (lHoras) lHoras.textContent = "Hrs";
      if (lMins) lMins.textContent = "Min";
      if (lSegs) lSegs.textContent = "Seg";

      horasEl.textContent = pad2(horas);
      minsEl.textContent = pad2(minutos);
      segsEl.textContent = pad2(segundos);

    }, 1000);

  }, 1000);

}



  function boot() {
    var cintillos = document.querySelectorAll(
      "#cintillo-diario[data-fecha-objetivo]"
    );
    if (!cintillos.length) return;
    for (var i = 0; i < cintillos.length; i++) {
      initCintillo(cintillos[i]);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();